
import { mixins, Options } from 'vue-class-component';
import WithModel from '../mixins/withModel';

@Options({})
export default class Toggle extends mixins(WithModel) {

}
